import GeographicalCountryStack from "components/company/sections/summary/adornments/GeographicalCountryStack";
import PinIcon from "components/company/sections/summary/icons/PinIcon";
import PropertyIcon from "components/company/sections/summary/icons/PropertyIcon";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";

interface IPropertyPlantEquipmentSummaryProps {
  propertyPlantEquipment: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["propertyPlantEquipment"]>;
}

export default function PropertyPlantEquipmentSummary({ propertyPlantEquipment }: IPropertyPlantEquipmentSummaryProps) {
  const propertiesCount = propertyPlantEquipment.length;
  const countries = new Set(
    propertyPlantEquipment
      .map((propertyPlantEquipment) => {
        return propertyPlantEquipment.geographicalCountry ? propertyPlantEquipment.geographicalCountry.isoCode : null;
      })
      .filter(notUndefinedOrNull),
  );

  return (
    <div className="flex items-center justify-between space-x-6 xl:justify-start">
      <div className="space-y-1 text-sm font-normal text-gray-600">
        <div className="flex items-center space-x-2">
          <PinIcon width={13} height={15} />
          <span>
            {countries.size} {countries.size === 1 ? "país" : "países"}
          </span>
        </div>

        <div className="flex items-center space-x-2">
          <PropertyIcon width={13} height={13} />
          <span>
            {propertiesCount} {propertiesCount === 1 ? "propriedade" : "propriedades"}
          </span>
        </div>
      </div>

      <GeographicalCountryStack
        geographicalCountries={propertyPlantEquipment
          .map(({ geographicalCountry }) => geographicalCountry || null)
          .filter(notUndefinedOrNull)}
      />
    </div>
  );
}
